
import * as OM from '@/model';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { BaseUserClient, DeferredPaymentClient } from '@/services/Services';
import { Prop } from "vue-property-decorator";
import store from '@/store';

@Options({})
export default class payWithDeferred extends Vue {

    acquistiInAttesa: OM.DeferredPayment[] = [];

    created(){
        DeferredPaymentClient.getPendingByCustomer(store.state.user.identifier)
        .then(x => {
            this.acquistiInAttesa = x;
        })
    }

};
